import Vue from 'vue'

const ToastInstance = Vue.extend(require('./dyScan.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null

let getInstance = () => {
  return new ToastInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (confirmResolve) {
    confirmResolve(false)
    confirmResolve = null
  }
  confirmPromise = null
}

let Toast = (msg) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  confirmPromise = new Promise((resolve, reject) => {
    confirmResolve = resolve
  })
  instance.open(msg, confirmResolve)

  return confirmPromise
}

export default Toast
